export default __webpack_public_path__ + "static/media/web-mockup-V3-right.9ab30536.png";